import { render, staticRenderFns } from "./mallOrder.vue?vue&type=template&id=f61f269c&scoped=true&"
import script from "./mallOrder.vue?vue&type=script&lang=js&"
export * from "./mallOrder.vue?vue&type=script&lang=js&"
import style0 from "./mallOrder.vue?vue&type=style&index=0&id=f61f269c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61f269c",
  null
  
)

export default component.exports